import { useLoaderData } from 'react-router';

import type { loader } from '@modules/professional/page/loaders/overview-page-loader.server';
import { DetailTestimonialBand } from '~/ui-rocco/pages/detail-shared';

/**
 * What the practice's clients have said, drawn by the band the product and
 * project pages use, so a review reads the same wherever it is quoted.
 *
 * The profile keeps its testimonials in the member's own order, under
 * `MemberSortOrder`; the band takes that as its `SortOrder`.
 */
export const ProfessionalAboutTestimonialSection = () => {
    const { professionalOverview } = useLoaderData<typeof loader>();

    const testimonials = (professionalOverview.professionalTestimonials ?? [])
        .filter((testimonial) => testimonial.Content)
        .map((testimonial) => ({
            ID: testimonial.ID,
            Content: testimonial.Content,
            Source: testimonial.Source,
            Location: testimonial.Location,
            SortOrder: testimonial.MemberSortOrder ?? 0,
        }));

    return (
        <DetailTestimonialBand
            label="Professional Reviews"
            testimonials={testimonials}
        />
    );
};
